import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { EstadosdeCuentaClientes } from '../modalEstadosdeCuentaClientes';

function CartasProveedores(props) {

  const [activate, setActivate] = useState(false);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [totalnotas, setTotalnotas] = useState(0);
  const [totaldeudas, setTotaldeudas] = useState(0);
  const [totalpagadas, setTotalpagadas] = useState(0);
  const [conteo, setConteo] = useState(0);
  const [opera, setOpera] = useState(0);
  const [mostrar, setMostrar] = useState(false);

  var op = require('../../../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  const accbtnclientes = JSON.parse(sessionStorage.getItem("accbtnclientesc"));

  const seleccionarTotalesClientesPagos = (id) => {

    let endpoint = `${op.conexion}/api/agente/totalespagos?id=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setTotalnotas(response.data.totalnotas);
          setTotaldeudas(response.data.todeudas);
          setTotalpagadas(response.data.tocanceladas);
          setConteo(response.data.idagente);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  useEffect(() => {

    if (props.valida === 1 && parseInt(props.idcliente) !== parseInt(conteo)) {
        seleccionarTotalesClientesPagos(props.idcliente);
    } else {
      seleccionarTotalesClientesPagos(props.idcliente);
    }
    
  }, [props.idcliente]);

  const onBotones = (op) => (e) => {
    e.preventDefault();

    if (op === 1) {
      setMostrar(true);
      setOpera(op);
    } else if (op === 2) {
      setMostrar(true);
      setOpera(op);
    } else if (op === 3) {
      setMostrar(true);
      setOpera(op);
    }
    
  };

  return (
    <div className="container">
      {props.valida === 1 ? <button className="col-md-10 mx-auto bg-transparent border-0 d-flex justify-content-center" onClick={onBotones(3)}
       disabled={totalnotas > 0 && accbtnclientes && accbtnclientes.toString().substring(4, 5) === "1" ? false : true}>
        <div className="card bg-card-info" style={{ height: '120px', width: '80%' }}>
          <div className='card-header text-center m-0 px-0' style={{ height: '60%' }}>
            Notas de Entregas Emitidas
          </div>
          <div className="card-body bg-light mx-1 mb-1 text-center">
            <label className='fw-bold fs-4'>{totalnotas > 0 ? totalnotas : 0}</label>
          </div>
        </div>
      </button> : <div className="col-md-10 mx-auto">
        <div className="card bg-card-info" style={{ height: '120px', width: '80%' }}>
          <div className='card-header text-center m-0 px-0' style={{ height: '60%' }}>
            Total {props.titulo} Registrados
          </div>
          <div className="card-body bg-light mx-1 mb-1 text-center">
            <label className='fw-bold fs-4'>{props.totalr}</label>
          </div>
        </div>
      </div>}
      
      {props.valida === 1 ? <button className="col-md-10 mx-auto bg-transparent border-0 d-flex justify-content-center" onClick={onBotones(1)}
       disabled={totaldeudas > 0 && accbtnclientes && accbtnclientes.toString().substring(4, 5) === "1" ? false : true}>
        <div className="card bg-danger" style={{ height: '120px', width: '80%' }}>
          <div className='card-header text-center' style={{ height: '60%' }}>
            Notas de Entrega por Pagar
          </div>
          <div className="card-body bg-light mx-1 mb-1 text-center">
            <label className='fw-bold fs-4'>{totaldeudas > 0 ? totaldeudas : 0}</label>
          </div>
        </div>
      </button> : <div className="col-md-10 mx-auto">
        <div className="card bg-card-success" style={{ height: '120px', width: '80%' }}>
          <div className='card-header text-center' style={{ height: '60%' }}>
            Total {props.titulo} Activos
          </div>
          <div className="card-body bg-light mx-1 mb-1 text-center">
            <label className='fw-bold fs-4'>{props.totalact}</label>
          </div>
        </div>
      </div>}
      
      {props.valida === 1 ? <button className="col-md-10 mx-auto bg-transparent border-0 d-flex justify-content-center" onClick={onBotones(2)}
       disabled={totalpagadas > 0 && accbtnclientes && accbtnclientes.toString().substring(4, 5) === "1" ? false : true}>
        <div className="card bg-card-success" style={{ height: '120px', width: '80%' }}>
          <div className='card-header text-center' style={{ height: '60%' }}>
            Notas de Entrega Pagadas
          </div>
          <div className="card-body bg-light mx-1 mb-1 text-center">
            <label className='fw-bold fs-4'>{totalpagadas > 0 ? totalpagadas : 0}</label>
          </div>
        </div>
      </button> : <div className="col-md-10 mx-auto">
        <div className="card bg-danger" style={{ height: '120px', width: '80%' }}>
          <div className='card-header text-center' style={{ height: '60%' }}>
            Total {props.titulo} Inactivos
          </div>
          <div className="card-body bg-light mx-1 mb-1 text-center">
            <label className='fw-bold fs-4'>{props.totalinc}</label>
          </div>
        </div>
      </div>}
      <EstadosdeCuentaClientes
        show={mostrar}
        onHideCancelar={() => setMostrar(false)}
        op={opera}
        client={props.idcliente}
        rif={props.rifclient}
      />
    </div>
    

  );
}

export default CartasProveedores;


// WEBPACK FOOTER //
// ./src/components/ventas/cartas/cartasProveedor.js